export const KONTROL_EK_SECENEKLER = [
  { id: 'musavirlik_hizmeti', name: 'Müşavirlik Hizmeti' },
];

// Sihirbaz + detay + filtre + export ortak seçenek listeleri (kodlu değer → okunabilir etiket)
export const IHALE_USULU_OPTIONS = [
  { value: '19_acik_ihale', label: '19/Açık İhale' },
  { value: '21b_pazarlik', label: '21b/Pazarlık' },
  { value: '21f_pazarlik', label: '21f/Pazarlık' },
  { value: '20_belirli_istekliler', label: '20/Belirli İstekliler Arasında İhale' },
  { value: '22d_dogrudan_temin', label: '22/d Doğrudan Temin' },
  { value: '2863_kultur', label: '2863 Sayılı Kültür Varlıkları' },
];

export const ALIM_TURU_OPTIONS = [
  { value: 'yapim', label: 'Yapım' },
  { value: 'proje_isleri', label: 'Proje İşleri' },
  { value: 'hizmet_isleri', label: 'Hizmet İşleri' },
  { value: 'danismanlik', label: 'Danışmanlık' },
];

export { TESIS_TURU_OPTIONS } from '../../../utils/tesisTuru';

export const SOZLESME_TURU_OPTIONS = [
  { value: 'birim_fiyat', label: 'Birim Fiyat' },
  { value: 'anahtar_teslim', label: 'Anahtar Teslim' },
];

export const IDARE_OPTIONS = [
  { value: 'il_mudurlugu', label: 'İl Müdürlüğü' },
  { value: 'yigm', label: 'YİGM' },
  { value: 'toki', label: 'TOKİ' },
];

export const ODENEK_DURUMU_OPTIONS = [
  { value: 'spor_toto', label: 'Spor Toto' },
  { value: 'strateji', label: 'Strateji' },
  { value: 'yigm', label: 'YİGM' },
];

export const KESIN_KABUL_OPTIONS = [
  { value: 'yapildi', label: 'Yapıldı' },
  { value: 'yapilmadi', label: 'Yapılmadı' },
];

export const VAR_YOK_OPTIONS = [
  { value: 'var', label: 'VAR' },
  { value: 'yok', label: 'YOK' },
];

export const labelOf = (options, value) => {
  if (value === null || value === undefined || value === '') return '';
  return options.find(o => o.value === value)?.label || String(value);
};

export const IHALE_EXPORT_COLUMNS = [
  {id: 'ihale_no', label: 'İhale No'}, {id: 'kayit_no', label: 'Kayıt No'},
  {id: 'yil', label: 'Yıl'}, {id: 'ihale_tarihi', label: 'İhale Tarihi'},
  {id: 'ihale_usulu', label: 'İhale Usulü'}, {id: 'alim_turu', label: 'Alım Türü'},
  {id: 'tesis_turu', label: 'Tesis Türü'},
  {id: 'sozlesme_turu', label: 'Sözleşme Türü'}, {id: 'sozlesme_tarihi', label: 'Sözleşme Tarihi'},
  {id: 'isin_adi', label: 'İşin Adı'}, {id: 'ilgilenen_memur', label: 'İlgilenen Memur'},
  {id: 'ilcesi', label: 'İlçe'}, {id: 'isi_yapan_idare', label: 'İşi Yapan İdare'},
  {id: 'enlem', label: 'Enlem'}, {id: 'boylam', label: 'Boylam'},
  {id: 'odenek_durumu', label: 'Ödenek Durumu'}, {id: 'odenek_tarihi', label: 'Gelen Ödenek Tarihi'}, {id: 'durumu', label: 'Durum'},
  {id: 'ihaleyi_alan_firma', label: 'İhaleyi Alan Firma'}, {id: 'firma_iletisim_adresi', label: 'Firma İletişim Adresi'},
  {id: 'yaklasik_maliyet', label: 'Yaklaşık Maliyet'}, {id: 'sozlesme_bedeli', label: 'Sözleşme Bedeli'},
  {id: 'is_artisi_1_var_mi', label: '1. İş Artışı Var mı'}, {id: 'is_artis_tutari_1', label: '1. İş Artış Tutarı'},
  {id: 'is_artis_orani_1', label: '1. İş Artış Oranı'}, {id: 'guncel_sozlesme_bedeli_1', label: '1. Güncel Sözleşme'},
  {id: 'is_artisi_2_var_mi', label: '2. İş Artışı Var mı'}, {id: 'is_artis_tutari_2', label: '2. İş Artış Tutarı'},
  {id: 'is_artis_orani_2', label: '2. İş Artış Oranı'}, {id: 'guncel_sozlesme_bedeli_2', label: '2. Güncel Sözleşme'},
  {id: 'is_artisi_3_var_mi', label: '3. İş Artışı Var mı'}, {id: 'is_artis_tutari_3', label: '3. İş Artış Tutarı'},
  {id: 'is_artis_orani_3', label: '3. İş Artış Oranı'}, {id: 'guncel_sozlesme_bedeli_3', label: '3. Güncel Sözleşme (Final)'},
  {id: 'is_artisi_var_mi', label: 'İş Artışı/Süre Uzatımı Var mı'},
  {id: 'ek_kesin_teminat', label: 'Ek Kesin Teminat'}, {id: 'revize_is_programi', label: 'Revize İş Programı'},
  {id: 'ilave_all_risk', label: 'İlave All Risk'}, {id: 'toplam_odenen_hakedis', label: 'Toplam Hakediş'},
  {id: 'alt_yuklenici_firma', label: 'Alt Yüklenici'}, {id: 'fiyat_farki', label: 'Fiyat Farkı'},
  {id: 'fiyat_farki_tutari', label: 'Fiyat Farkı Tutarı'}, {id: 'yer_teslim_tarihi', label: 'Yer Teslim Tarihi'},
  {id: 'isin_suresi', label: 'İşin Süresi (Gün)'}, {id: 'bitis_tarihi', label: 'Bitiş Tarihi'},
  {id: 'ilave_sure', label: 'Süre Uzatımı (Gün)'}, {id: 'sure_uzatimi', label: 'İlave Süreli İş Bitim Tarihi'},
  {id: 'gecici_kabul_tarihi', label: 'Geçici Kabul Tarihi'}, {id: 'teminat_suresi_ay', label: 'Teminat Süresi (Ay)'},
  {id: 'kesin_kabul_tarihi', label: 'Kesin Kabul Tarihi'}, {id: 'kesin_teminat_mektubu', label: 'Kesin Teminat'},
  {id: 'kesin_kabul_durumu', label: 'Kesin Kabul Durumu'}, {id: 'nakdi_ilerleme', label: 'Nakdi İlerleme (%)'},
  {id: 'fiziki_ilerleme', label: 'Fiziki İlerleme (%)'}, {id: 'kontrol_teskilati', label: 'Kontrol Teşkilatı'},
  {id: 'insaat', label: 'İnşaat'}, {id: 'elektrik', label: 'Elektrik'},
  {id: 'mekanik', label: 'Mekanik'}, {id: 'ziraat', label: 'Ziraat'},
  {id: 'aciklama', label: 'Açıklama'}
];

export const ISTANBUL_ILCELERI = [
  'İSTANBUL',
  'ADALAR', 'ARNAVUTKÖY', 'ATAŞEHİR', 'AVCILAR', 'BAĞCILAR', 'BAHÇELİEVLER', 
  'BAKIRKÖY', 'BAŞAKŞEHİR', 'BAYRAMPAŞA', 'BEŞİKTAŞ', 'BEYKOZ', 'BEYLİKDÜZÜ',
  'BEYOĞLU', 'BÜYÜKÇEKMECE', 'ÇATALCA', 'ÇEKMEKÖY', 'ESENLER', 'ESENYURT',
  'EYÜPSULTAN', 'FATİH', 'GAZİOSMANPAŞA', 'GÜNGÖREN', 'KADIKÖY', 'KAĞITHANE',
  'KARTAL', 'KÜÇÜKÇEKMECE', 'MALTEPE', 'PENDİK', 'SANCAKTEPE', 'SARIYER',
  'SİLİVRİ', 'SULTANBEYLİ', 'SULTANGAZİ', 'ŞİLE', 'ŞİŞLİ', 'TUZLA',
  'ÜMRANİYE', 'ÜSKÜDAR', 'ZEYTİNBURNU'
];

export const IHALE_DURUMLARI = [
  { value: 'iptal_edildi', label: 'İptal Edildi' },
  { value: 'yikim_sureci', label: 'Yıkım Süreci' },
  { value: 'tasfiye_edildi', label: 'Tasfiye Edildi' },
  { value: 'proje_asamasinda', label: 'Proje Aşamasında' },
  { value: 'planlanan', label: 'Planlanan' },
  { value: 'tamamlandi', label: 'Tamamlandı' },
  { value: 'devam_ediyor', label: 'Devam Ediyor' },
  { value: 'ihale_surecinde', label: 'İhale Sürecinde' },
  { value: 'gecici_kabul', label: 'Geçici Kabul Aşamasında' }
];

export const INITIAL_FORM_DATA = {
  yil: new Date().getFullYear(),
  ihale_no: '',
  kayit_no: '',
  ihale_tarihi: '',
  ihale_usulu: '',
  alim_turu: '',
  tesis_turu: [],
  sozlesme_turu: '',
  sozlesme_tarihi: '',
  isin_adi: '',
  ilgilenen_memur: '',
  ilcesi: '',
  isi_yapan_idare: '',
  odenek_durumu: '',
  odenek_tarihi: '',
  durumu: '',
  ihaleyi_alan_firma: '',
  firma_iletisim_adresi: '',
  yaklasik_maliyet: '',
  sozlesme_bedeli: '',
  is_artisi_1_var_mi: '',
  is_artis_tutari_1: '',
  is_artis_orani_1: '',
  guncel_sozlesme_bedeli_1: '',
  is_artisi_2_var_mi: '',
  is_artis_tutari_2: '',
  is_artis_orani_2: '',
  guncel_sozlesme_bedeli_2: '',
  is_artisi_3_var_mi: '',
  is_artis_tutari_3: '',
  is_artis_orani_3: '',
  guncel_sozlesme_bedeli_3: '',
  is_artisi_var_mi: '',
  ek_kesin_teminat: '',
  revize_is_programi: '',
  ilave_all_risk: '',
  toplam_odenen_hakedis: '',
  alt_yuklenici_firma: '',
  fiyat_farki: '',
  fiyat_farki_tutari: '',
  sure_uzatimi: '',
  yer_teslim_tarihi: '',
  isin_suresi: '',
  ilave_sure: '',
  gecici_kabul_tarihi: '',
  teminat_suresi_ay: '',
  nakdi_ilerleme: '',
  fiziki_ilerleme: '',
  kontrol_teskilati: [],
  kesin_kabul_tarihi: '',
  kesin_teminat_mektubu: '',
  bitis_tarihi: '',
  kesin_kabul_durumu: '',
  aciklama: '',
  enlem: '',
  boylam: '',
  insaat: false,
  elektrik: false,
  mekanik: false,
  ziraat: false
};

export const INITIAL_FILTERS = {
  yil: [], ihale_no: '', kayit_no: '', isin_adi: '', ilcesi: [], durumu: [],
  alim_turu: [], tesis_turu: [], sozlesme_turu: [], ihale_usulu: [], ilgilenen_memur: [],
  ihaleyi_alan_firma: '', isi_yapan_idare: [], kontrol_teskilati: [],
  odenek_durumu: [], kesin_kabul_durumu: [], fiyat_farki: [], is_artisi_1: [],
  aciklama: '', yaklasik_maliyet_min: '', sozlesme_bedeli_min: '', hakedis_min: '',
  odenek_tarihi_bas: '', odenek_tarihi_bit: ''
};

// "2026-06-15", "15.06.2026" veya "15/06/2026" → "2026-06-15" (karşılaştırılabilir ISO)
export const toISODate = (v) => {
  if (!v) return '';
  const s = String(v).trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const m = s.match(/^(\d{1,2})[./-](\d{1,2})[./-](\d{4})$/);
  if (m) return `${m[3]}-${m[2].padStart(2, '0')}-${m[1].padStart(2, '0')}`;
  return '';
};
